import validate from "/home/forge/pininfarina.it/releases/20250625182455/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/forge/pininfarina.it/releases/20250625182455/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-media-hub": () => import("/home/forge/pininfarina.it/releases/20250625182455/middleware/authMediaHub.js")
}